import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="py-16 text-white bg-gray-900">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid gap-8 mb-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Company Info */}
          <div>
            <div className="mb-4 text-2xl font-bold text-transparent bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text">
              Govind Sinha & Co.
            </div>
            <p className="mb-6 text-gray-400">
              Your trusted partner for comprehensive chartered accountancy
              services, delivering excellence with integrity and precision.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://x.com/cagovindsinha"
                className="flex items-center justify-center w-10 h-10 transition-colors bg-blue-600 rounded-full hover:bg-blue-700"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/ca-govind-sinha-b92306173/"
                className="flex items-center justify-center w-10 h-10 transition-colors bg-blue-800 rounded-full hover:bg-blue-900"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/sinha.govind"
                className="flex items-center justify-center w-10 h-10 transition-colors bg-blue-600 rounded-full hover:bg-blue-700"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="mb-4 text-xl font-bold">Our Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a
                  href="/services"
                  className="transition-colors hover:text-yellow-400"
                >
                  Tax Advisory
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="transition-colors hover:text-yellow-400"
                >
                  Audit & Assurance
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="transition-colors hover:text-yellow-400"
                >
                  Business Registration
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="transition-colors hover:text-yellow-400"
                >
                  Financial Planning
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="transition-colors hover:text-yellow-400"
                >
                  Bookkeeping
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="transition-colors hover:text-yellow-400"
                >
                  Business Consulting
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 text-xl font-bold">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link
                  to="/"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="transition-colors hover:text-yellow-400"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/#about"
                  className="transition-colors hover:text-yellow-400"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="transition-colors hover:text-yellow-400"
                  // onClick={() => window.scrollTo(0, 0)}
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/checklists"
                  className="transition-colors hover:text-yellow-400"
                  // onClick={() => window.scrollTo(0, 0)}
                >
                  Checklists
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/pay"
                  className="transition-colors hover:text-yellow-400"
                  // onClick={() => window.scrollTo(0, 0)}
                >
                  Make Payment
                </Link>
              </li> */}
              <li>
                <Link
                  to="/#resources"
                  className="transition-colors hover:text-yellow-400"
                >
                  Resources
                </Link>
              </li>

              <li>
                <Link
                  to="/#testimonials"
                  className="transition-colors hover:text-yellow-400"
                >
                  Testimonials
                </Link>
              </li>
              <li>
                <Link
                  to="/#contact"
                  className="transition-colors hover:text-yellow-400"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="mb-4 text-xl font-bold">Contact Info</h3>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-start space-x-2">
                <svg
                  className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <a
                  href="https://maps.app.goo.gl/vxBFC4HWTFof4oGV8"
                  className="text-sm transition-colors hover:text-yellow-400"
                >
                  7th Floor, Adharshila Complex, 503, beside Reserve Bank of
                  India(RBI, South Gandhi Maidan, Patna, Bihar 800001
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <svg
                  className="flex-shrink-0 w-5 h-5 text-yellow-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <p>
                  <a
                    href="tel:+917673040500"
                    className="block text-sm transition-colors hover:text-yellow-400"
                  >
                    +91 7673040500
                  </a>

                  <a
                    href="tel:+919334743600"
                    className="block text-sm transition-colors hover:text-yellow-400"
                  >
                    +91 9934743600
                  </a>
                </p>
              </div>
              <div className="flex items-center space-x-2">
                <svg
                  className="flex-shrink-0 w-5 h-5 text-yellow-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <a
                  href="mailto:govind@cagovindsinha.com"
                  className="text-sm transition-colors hover:text-yellow-400"
                >
                  govind@cagovindsinha.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col items-center justify-between md:flex-row">
            <p className="mb-4 text-sm text-gray-400 md:mb-0">
              © {year} Govind Sinha & Co. All rights reserved.
              <br />
              Made by{" "}
              <span className="relative inline-block group">
                <a
                  href="mailto:amansinha@proton.me"
                  className="hover:text-yellow-400"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Aman Kumar Sinha.
                </a>
                <div className="absolute px-4 py-2 text-sm font-medium text-gray-800 transition-all duration-300 transform -translate-x-1/2 border shadow-lg opacity-0 bg-white/90 backdrop-blur-md rounded-xl -top-12 left-1/2 group-hover:opacity-100 group-hover:-translate-y-1 whitespace-nowrap border-white/20">
                  <span className="inline-flex items-center gap-2 ">
                    <Mail className="w-4 h-4" />
                    amansinha@proton.me
                  </span>
                  <div className="absolute w-2 h-2 transform rotate-45 -translate-x-1/2 border-b border-r bg-white/90 backdrop-blur-md -bottom-1 left-1/2 border-white/20"></div>
                </div>
              </span>
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <Link
                to="/privacy-policy"
                // onClick={() => window.scrollTo(0, 0)}
                className="transition-colors hover:text-yellow-400"
              >
                Privacy Policy
              </Link>
              <Link
                to="/disclaimer"
                // onClick={() => window.scrollTo(0, 0)}
                className="transition-colors hover:text-yellow-400"
              >
                Disclaimer
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
